import {
  appNavigate,
  replaceUnderscoresWithSpaces,
} from "../../../utils/functions"
import SectionsTitle from "../../../Common/new/SectionsTitle"
import React, { memo, useEffect, useMemo } from "react"
import * as style from "./caseStudies.module.css"
import LinkArrow from "../../svg/new/LinkArrow"
import { Link } from "gatsby"
import "aos/dist/aos.css"
import AOS from "aos"

const CaseStudies = ({
  CustomClass,
  homeCaseContent,
  homeCaseTitle,
  homeCaseShowSection,
  homeCaseSubTitle,
  selectCaseStudies,
}) => {
  useEffect(() => {
    AOS.init({
      once: true,
    })
  }, [])

  const filteredCaseStudies = useMemo(
    () => selectCaseStudies?.slice(0, 3) || [],
    [selectCaseStudies]
  )

  return (
    <>
      {homeCaseShowSection === "yes" && (
        <section
          className={`${CustomClass}`}
          data-aos="fade-up"
          data-aos-delay="50"
        >
          <div className="container">
            <div className={style.case_studies_wrap}>
              <SectionsTitle
                title={replaceUnderscoresWithSpaces(homeCaseTitle)}
                SubTitle={homeCaseSubTitle}
                Content={homeCaseContent}
                btnName="View All"
                href="/case-studies"
              />
              <div className="swiper-slider case_studies_swiper case-study-slider">
                {filteredCaseStudies?.map((item, index) => {
                  return (
                    <div className="swiper-slide" key={`${item}_${index}`}>
                      <div
                        className={style.portfoliolist}
                        style={{
                          backgroundImage: `url(${
                            item?.featuredImage?.node?.mediaItemUrl
                              ? item?.featuredImage?.node?.mediaItemUrl
                              : "/images/placeholder-image.jpg"
                          })`,
                        }}
                      >
                        <Link
                          onClick={e => {
                            e.preventDefault()
                            appNavigate(`/case-studies/${item?.slug}`)
                          }}
                          to={`/case-studies/${item?.slug}`}
                          className={style.LinkBtn}
                        >
                          {" "}
                          <div style={{ lineHeight: "1" }}>View</div>{" "}
                          <i>
                            <LinkArrow />
                          </i>{" "}
                        </Link>
                        <div className={style.TagWrapper}>
                          <div className={style.TagBox}>
                            {" "}
                            {item?.CaseStudiesPostFieldsNew?.caseIndustry
                              ? item?.CaseStudiesPostFieldsNew?.caseIndustry
                              : "null"}
                          </div>
                          <div className={style.TagBox}>
                            {item?.CaseStudiesPostFieldsNew?.caseCountry}
                          </div>
                        </div>
                        <div className={style.CaseStudiesInfo}>
                          <h3>{item?.title}</h3>
                          <div>
                            <span>Web </span> <span>UI UX Design</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                })}
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  )
}

export default memo(CaseStudies)
